"use strict";

!function(a){a.fn.datepicker.dates.tr={days:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],daysShort:["Pz","Pzt","Sal","Çrş","Prş","Cu","Cts"],daysMin:["Pz","Pzt","Sa","Çr","Pr","Cu","Ct"],months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthsShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],today:"Bugün",clear:"Temizle",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.ru={days:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],daysShort:["Вск","Пнд","Втр","Срд","Чтв","Птн","Суб"],daysMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Сегодня",clear:"Очистить",format:"dd.mm.yyyy",weekStart:1,monthsTitle:"Месяцы"}}(jQuery);
!function(a){a.fn.datepicker.dates.de={days:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],daysShort:["Son","Mon","Die","Mit","Don","Fre","Sam"],daysMin:["So","Mo","Di","Mi","Do","Fr","Sa"],months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthsShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],today:"Heute",monthsTitle:"Monate",clear:"Löschen",weekStart:1,format:"dd.mm.yyyy"}}(jQuery);

var Custom = {
    initForm: function(){
        $('.CrudFormRedirectButton a').click(function (e) {
            e.preventDefault();

            $(this).parents('form').find('input[name=typeRedirect]').val($(this).attr('data-type-redirect'));
            $(this).parents('form').submit();
        })
    },
    init: function () {

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });


        moment.locale(_config.moment_locale);

        /*
        $('[data-fancybox]').fancybox({
            protect: true,
            beforeLoad:function (instance) {
                instance.update();
            },
            beforeShow:function (instance) {
                instance.update();
            },
        });*/

        Custom.initForm();

    },
};

"use strict";
window.GoogleColumnCharts = {
    loadingHtml: '<div class="kt-spinner kt-spinner--v2 kt-spinner--md kt-spinner--info"></div>',
    charts: [],
    initAjax: function (chartForm)
    {
        chartForm.find('.google-column-chart').html(window.GoogleColumnCharts.loadingHtml);

        $.ajax({
            url: chartForm.attr('action'),
            type: chartForm.attr('method'),
            data: chartForm.serialize()
        }).always(function(response) {
            if(typeof response.status === 'boolean' && response.status)
            {
                window.GoogleColumnCharts.initChart(chartForm.find('.google-column-chart'),response.data,response.options);
            }
            else
            {
                chartForm.find('.google-column-chart').html('<h4 class="kt-font-danger">'+_translation['somethingWentWrong']+'</h4>');
            }

        });
    },
    initChart: function(chart,data,options)
    {
        var googleChart = new google.visualization.ColumnChart(chart[0]);

        googleChart.draw(google.visualization.arrayToDataTable(data), options);
    },
    initCharts: function() {

        $('.google-column-chart-container').each(function () {
            window.GoogleColumnCharts.initAjax($(this));

            $(this).find('.kt-select2').change(function () {
                window.GoogleColumnCharts.initAjax($(this).parents('.google-column-chart-container'));
            });
        });

    },
    init: function () {
        google.load('visualization', '1', {
            packages: ['corechart', 'bar', 'line']
        });

        google.setOnLoadCallback(function() {
            window.GoogleColumnCharts.initCharts();
        });
    }
};

//window.GoogleColumnCharts.init();


window.Address = {
    selector: [],
    cityChange: function(city,selectors) {
        window.Address.valReset('district',selectors);
        window.Address.valReset('neighbourhood',selectors);
        window.Address.valReset('street',selectors);
    },
    districtChange: function(district,selectors) {
        window.Address.valReset('neighbourhood',selectors);
        window.Address.valReset('street',selectors);
    },
    neighbourhoodChange: function(neighbourhood,selectors) {
        window.Address.valReset('street',selectors);
    },
    valReset: function(type,selectors)
    {
        if (typeof selectors[type] !== 'undefined')
        {
            $('[name='+selectors[type]+']').val(null).trigger('change');
        }
    },
    initAjaxSelect2: function(selectors) {

        if (typeof selectors.district !== 'undefined')
        {
            $('[name='+selectors.district+']').select2({
                ajax: {
                    url: _route["ajax.districts"],
                    method: 'POST',
                    data: function (params) {
                        var query = {
                            search: params.term,
                            page: params.page || 1,
                            "city_id": $('[name='+selectors.city+']').val()
                        };

                        return query;
                    },
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: data.items
                        };
                    },
                }
            });
        }

        if (typeof selectors.neighbourhood !== 'undefined')
        {
            $('[name='+selectors.neighbourhood+']').select2({
                ajax: {
                    url: _route["ajax.neighbourhoods"],
                    method: 'POST',
                    data: function (params) {
                        var query = {
                            search: params.term,
                            page: params.page || 1,
                            "district_id": $('[name='+selectors.district+']').val()
                        };

                        return query;
                    },
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: data.items
                        };
                    },
                }
            });
        }

        if (typeof selectors.street !== 'undefined')
        {
            $('[name='+selectors.street+']').select2({
                ajax: {
                    url: _route["ajax.streets"],
                    method: 'POST',
                    data: function (params) {
                        var query = {
                            search: params.term,
                            page: params.page || 1,
                            "neighbourhood_id": $('[name='+selectors.neighbourhood+']').val()
                        };

                        return query;
                    },
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: data.items
                        };
                    },
                }
            });
        }
    },
    init: function () {

        $.each(Address.selector,function (key,item) {
            window.Address.initAjaxSelect2(item);
            $('[name='+item.city+']').change(function () {
                window.Address.cityChange(this,item);
            });
            if (typeof item.district !== 'undefined') {
                $('[name='+item.district+']').change(function () {
                    window.Address.districtChange(this,item);
                });
            }
            if (typeof item.neighbourhood !== 'undefined') {
                $('[name='+item.neighbourhood+']').change(function () {
                    window.Address.neighbourhoodChange(this,item);
                });
            }
        });
    },
};


$(document).ready(function () {
    Custom.init();
});

